export class LocalStorageManager {
  getItem (primaryKey: string, ...otherKeys: string[]): object | string | number | null {
    try {
      const storedValue = localStorage.getItem(primaryKey)
      if (storedValue === null) return null

      let localStorageItem: unknown = JSON.parse(storedValue)
      for (const key of otherKeys) {
        if (typeof key !== 'string') throw new Error('Key is not a string!')
        if (typeof localStorageItem !== 'object' || localStorageItem === null) return null

        localStorageItem = (localStorageItem as Record<string, unknown>)[key]
        if (localStorageItem === undefined) return null
      }
      return localStorageItem as object | string | number | null
    } catch (error) {
      console.log(error)
      return null
    }
  }

  setItem (item: object | string | number, primaryKey: string, ...otherKeys: string[]): void {
    try {
      this.setDefaultValue(primaryKey)
      if (otherKeys.length > 0) {
        const localStorageItem = JSON.parse(localStorage.getItem(primaryKey) ?? '')
        const lastKey = otherKeys.pop() as string
        let pointer = localStorageItem
        otherKeys.forEach((key) => {
          if (typeof key !== 'string') throw new Error('Key is not a string!')
          pointer[key] ??= {}
          pointer = pointer[key]
        })
        pointer[lastKey] = item
        localStorage.setItem(primaryKey, JSON.stringify(localStorageItem))
      } else {
        localStorage.setItem(primaryKey, JSON.stringify(item))
      }
    } catch (error) {
      console.log(error)
    }
  }

  setDefaultValue (primaryKey: string): void {
    if (localStorage.getItem(primaryKey) === null) localStorage.setItem(primaryKey, '{}')
  }
}
